import React from 'react';
import type { FieldInputProps } from 'formik';
import KoobInputText from '../KoobInputText';
import KoobInputNumber from '../KoobInputNumber';

type KoobFormikInputProps = Omit<
  React.ComponentProps<typeof KoobInputText>,
  'name' | 'value' | 'onChange'
> & {
  /** `field` from formik's useField / Field render props */
  field: FieldInputProps<string | number | null | undefined>;
  /** Formik setter for this field (helpers.setValue, or form.setFieldValue bound to the name) */
  setValue: (value: number | string) => void;
};

/**
 * Formik-bound input shared by the per-app `TextField` wrappers, which keep
 * their own label and error layout. `type="number"` renders a KoobInputNumber
 * and keeps formik's own convention: a number, or '' when the field is empty.
 */
const KoobFormikInput = ({
  field,
  setValue,
  ...props
}: KoobFormikInputProps) =>
  props.type === 'number' ? (
    <KoobInputNumber
      {...props}
      name={field.name}
      value={field.value}
      onValueChange={(value) => setValue(value ?? '')}
      onBlur={field.onBlur}
    />
  ) : (
    <KoobInputText {...field} value={field.value ?? undefined} {...props} />
  );

export default KoobFormikInput;
